import {FC} from 'react'
import {BsFillCheckCircleFill} from 'react-icons/bs'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {addParkingNameAction, unauthCarAdd} from '../../../../../setup/redux/actions/actions'
import {useIntl} from 'react-intl'
import successIcon from '../../../../assets/success_frame.png'

import './PaymentResult.css'

const SaveCardSuccessForm: FC = () => {
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const intl = useIntl()
    return (
        <>
            <div className='d-flex flex-column p-10 pt-20 h-100' >
                <img src={successIcon} />
                <div className='d-flex flex-column justify-content-between h-100'>
                    <div className='d-flex flex-column gap-3 align-items-center' style={{height: '40%'}}>
                        <span className='authorization_title'>{intl.formatMessage({id: 'SUCCESS.CONGRATS.CARD'})}</span>
                        <span className='authorization_description'>{intl.formatMessage({id: 'SUCCESS.CONGRATS.MSG.CARD'})}</span>
                    </div>

                    <div className='d-flex flex-column gap-3 mb-5 justify-content-end' style={{height: '60%'}}>
                        <button className='primary-button' onClick={() => navigate('/parking-payment')}>{intl.formatMessage({id: 'BTNS.CONTINUE'})}</button>
                    </div>
                </div>

            </div>
        </>
    )
}

export {SaveCardSuccessForm}
